import { Injectable, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, mergeMap, Observable, tap } from 'rxjs';
import { CommonModule } from '@angular/common';

export type Features = {
    [key: string]: boolean;
};

@Injectable({ providedIn: 'root' })
export class FeatureService {
    private basePath: string;
    private readonly featuresSource = new BehaviorSubject<Features | null>(null);
    public readonly features$ = this.featuresSource.asObservable();

    constructor(private readonly http: HttpClient) {}

    get features(): Features {
        return this.featuresSource.getValue() ?? {};
    }

    public setBasePath(basePath: string) {
        this.basePath = basePath;
    }

    public setFeatures(features: Features): void {
        this.featuresSource.next(features);
    }

    public loadFeatures(tokenRaw: string, basePath: string = null, encounterId?: number): Observable<Features> {
        if (!basePath && !this.basePath) {
            throw new Error('Feature service base path is not set! Unable to load features.');
        }

        if (basePath) {
            this.basePath = basePath;
        }

        let url = `${this.basePath}/feature`;
        if (encounterId && !isNaN(encounterId)) {
            url += `?encounterId=${encodeURIComponent(encounterId)}`;
        }
        return this.http
            .get<Features>(url, {
                headers: { Authorization: `Bearer ${tokenRaw}` },
            })
            .pipe(
                tap((features) => this.setFeatures(features)),
                mergeMap(() => this.features$),
            );
    }
}

@NgModule({
    imports: [CommonModule],
    declarations: [],
})
export class FeatureServiceModule {}
